<div class="d-flex flex-row align-items-center modal-header-icon-container dialog-gap fw-bold">
  <i class="fs-4 pi pi-info-circle"></i>
  <h5 class="m-0 bold">MI Quote</h5>
</div>

<div [formGroup]="miQuoteFormGroup">
  <div class="row">
    <div class="d-flex align-items-center surface-border surface-overlay w-100">
      <p class="mt-0 text-base w-10">
        The information below is used for the quote only, it is not saved to the loan file unless you accept the quote.
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <label class="control-label" for="LTV">Base LTV <span class="color-danger">*</span></label>
      <p-inputNumber
        class="w-100"
        styleClass="form-control input-span"
        formControlName="ltv"
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
        suffix="%"
        placeholder="0.00"
      />
      <cmg-validator-messages [control]="miQuoteFormGroup.get('ltv')" />
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-md-12">
      <label class="control-label" for="coverage"
        >Coverage <span class="fw-normal">(enter a value between 6 and 35) </span> <span class="color-danger">*</span></label
      >
      <cmg-decimal-input
        class="w-100"
        styleClass="form-control input-span"
        formControlName="coverage"
        type="percent"
        placeholder="0"
        fractionDigits="0"
        cmgFormControlFactorReset
      />
      <cmg-validator-messages [control]="miQuoteFormGroup.get('coverage')" />
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-md-12">
      <label class="control-label" for="creditScore">Estimated Credit Score <span class="color-danger">*</span></label>
      <p-inputNumber styleClass="form-control input-span" placeholder="000" [maxFractionDigits]="0" formControlName="creditScore" />
      <cmg-validator-messages [control]="miQuoteFormGroup.get('creditScore')" />
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-md-12">
      <label class="control-label">PMI Type <span class="color-danger">*</span></label>
      <p-select
        class="w-100"
        formControlName="pmiType"
        [options]="pmiTypeOptions"
        [optionLabel]="'name'"
        [optionValue]="'value'"
        placeholder="Select"
        appendTo="body"
      />
      <cmg-validator-messages [control]="miQuoteFormGroup.get('pmiType')" />
    </div>
  </div>
  <br />
  @if (showUFMIPF) {
    <div class="row">
      <div class="col-md-12">
        <label class="control-label">UFMIP Financing <span class="color-danger">*</span></label>
        <p-select class="w-100" formControlName="UFMIPF" [options]="upfrontMiTypeOptions" optionLabel="name" optionValue="value" appendTo="body" />
        <cmg-validator-messages [control]="miQuoteFormGroup.get('UFMIPF')" />
      </div>
    </div>
  }
  <br />
  @if (showUFMIPP) {
    <div class="row">
      <div class="col-md-12">
        <label class="control-label" for="UFMIPP">UFMIP Percent <span class="color-danger">*</span></label>
        <cmg-decimal-input
          class="w-100"
          styleClass="form-control input-span"
          formControlName="UFMIPP"
          type="percent"
          placeholder="0.000"
          fractionDigits="3"
          max="100"
          min="0"
          cmgFormControlFactorReset
        />
        <cmg-validator-messages [control]="miQuoteFormGroup.get('UFMIPP')" />
      </div>
    </div>
  }
  <div class="dialog-button-container">
    <button pButton type="button" severity="secondary" class="fw-bold mx-2" (click)="clear()">Cancel</button>
    <button pButton type="button" class="fw-bold" [disabled]="submitDisable" (click)="onGetMIQuoteResult()">Submit</button>
  </div>
</div>

<p-toast />
@if (isLoading$ | async) {
  <cmg-clear2-ui-busy-indicator class="dialog position-relative" [loadingMessage]="loadingMessage$ | async" />
}
